export default __webpack_public_path__ + "static/media/ios-2.6fb8341a.jpeg";